import cookie from "cookiejs";
import PageTitle from "./js/components/pageTitle";

const delegate = require('delegate');

document.addEventListener('DOMContentLoaded', (event) => {
    const pageTitle = new PageTitle();
    const applyCartQuantityMask = _ => $('input[name="cart_quantity[]"]').mask('00000');

    applyCartQuantityMask();

    function renderCartHeader(html) {
        $('.cart').html(html);
    }

    function handleAbandonedCart() {
        if ('object' === typeof sendinblue) {
            $.getJSON('/bebida/abandoned_cart.php', function (data) {
                if (null !== data) {
                    sendinblue.track(
                        data.action,
                        {
                            "email": data.customer_email
                        },
                        {
                            "id": data.cart.id,
                            "data": data.cart
                        }
                    );
                }
            });
        }
    }

    const handleSubtotalObserver = _ => {
        const cartSummarySubtotal = document.querySelector('.jsCartSummarySubtotalTrigger');

        if (cartSummarySubtotal) {
            const subtotalObserver = new IntersectionObserver(
                entries => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            document.querySelector('.cartSummary__subtotal').classList.remove('cartSummary__subtotal--fixed');
                        } else {
                            document.querySelector('.cartSummary__subtotal').classList.add('cartSummary__subtotal--fixed');
                        }
                    });
                },
                {
                    root: null,
                    threshold: 0,
                    rootMargin: '0px 0px 0px 0px',
                }
            );
            subtotalObserver.observe(document.querySelector('.jsCartSummarySubtotalTrigger'));
        }
    };
    handleSubtotalObserver();

    const handleSubmit = async (url, form) => {
        const shoppingCart = document.querySelector('.shoppingCart-container');
        const decoder = new TextDecoder('iso-8859-1');

        const cartResponse = await fetch(url, {
            method: 'POST',
            body: new FormData(form),
        });
        shoppingCart.innerHTML = decoder.decode(await cartResponse.arrayBuffer());
        if (shoppingCart.querySelector('.miniCart__productList__emptyMessage')) {
            document.querySelector('body').classList.add('shopping-cart-page--empty');
            document.querySelector('body').classList.remove('with-products');
        }

        const cartHeaderResponse = await fetch('/bebida/render_shopping_cart_header.php?js-render=true', {
            method: 'POST',
        });
        document.querySelector('.cart').innerHTML = await cartHeaderResponse.text();

        const miniCartContainer = document.querySelector('.miniCart__container');
        if (!miniCartContainer) {
            return;
        }

        miniCartContainer.addEventListener('mouseover', _ => miniCartContainer.classList.add('active'));
        miniCartContainer.addEventListener('mouseleave', _ => miniCartContainer.classList.remove('active'));
        handleSubtotalObserver();
    }

    function showPostalcodePopup(url, form) {
        $.fancybox.open({
            src: '/bebida/popup_stock.php',
            type: 'ajax',
            modal: true,
            afterClose: function () {
                handleSubmit(url, form);
                $('.header__sticky').load('/bebida/includes/header_logos.php');
            }
        });

        if ('function' === typeof ga) {
            ga('send', {
                hitType: 'event',
                eventCategory: 'Carrinho',
                eventAction: 'Abertura popup estoque'
            });
        }
    }

    const shoppingCartRender = async (url, form) => {
        const firstPopupShow = false === cookie.get('cep') && !cookie.get('totem');
        const cep = cookie.get('cep');

        if (
            firstPopupShow
            || '00000000' === cep
        ) {
            showPostalcodePopup(url, form);
        } else {
            await handleSubmit(url, form);
        }
    }

    function showIcedPopup() {
        $.fancybox.open(
            {
                src: '/bebida/iced.php',
                type: 'ajax',
            },
            {
                parentEl: '.iced__wrapper',
                animationEffect: 'zoom-in-out',
                autoFocus: false,
                touch: false,
                infobar: false,
                toolbar: false,
                closeClickOutside: false,
                beforeClose: async (instance, current, e) => {
                    let formData = new FormData(document.querySelector('.iced__popup'));
                    if ('undefined' !== typeof e) {
                        formData.append('iced', 0);
                    }

                    const icedResponse = await fetch('/bebida/iced.php', {
                        method: 'POST',
                        body: formData
                    });

                    const isJson = icedResponse.headers.get('content-type')?.includes('application/json');
                    if (isJson) {
                        const data = await icedResponse.json();
                        if (data['redirect']) {
                            window.location.href = '/bebida/checkout_address.php';

                            return;
                        }
                    }

                    await shoppingCartRender('/bebida/render_shopping_cart.php?js-render-cart=true');

                    pageTitle.restoreLast();
                },
            }
        );
    }

    function showCouponPopup() {
        $.fancybox.open(
            {
                src: document.getElementById('cartCouponPopup'),
                type: 'inline',
            },
            {
                parentEl: document.querySelector('.shoppingCart-container'),
                autoFocus: false,
                touch: false,
                infobar: false,
                toolbar: false
            }
        );
    }

    const sendMoengageEvent = (eventName, eventData) => {
        try {
            if ('undefined' !== typeof Moengage) {
                Object.entries(eventData).forEach(([key, value]) => {
                    if (!value) {
                        delete (eventData[key]);

                        return;
                    }
                    if (/_name$/.test(key)) {
                        eventData[key] = decodeURIComponent(value)
                    }
                });
                Moengage.track_event(eventName, eventData);

                const moengageCart = JSON.parse(document.querySelector('.cartMini').dataset?.moengageCart)
                if (moengageCart) {
                    Moengage.track_event('cart_viewed', moengageCart);
                }
            }
        } catch (e) {
            console.error(e);
        }
    };

    delegate(
        document.querySelectorAll('.shoppingCart-container, .js-cart ~ .cartMini, .js-cart ~ .miniCart--desktop .miniCart__content'),
        '.js-remove, .js-cartProductRemove',
        'click',
        async e => {
            const queryString = e.delegateTarget.href.slice(e.delegateTarget.href.indexOf('?'));

            e.preventDefault();

            await shoppingCartRender(`/bebida/render_shopping_cart.php${queryString}&js-render-cart=true`);

            let moengageEventData;
            if (e.delegateTarget?.dataset.moengageEventData) {
                try {
                    moengageEventData = JSON.parse(e.delegateTarget?.dataset.moengageEventData);
                    sendMoengageEvent('removed_from_cart', moengageEventData);
                } catch (e) {

                }
            }
        }
    );
    $('.shoppingCart-container')
        .on('click', '.card__submit, [name="btnUpdateCart_x"]', async e => {
            const form = e.currentTarget.closest('form');

            e.preventDefault();

            await shoppingCartRender('/bebida/render_shopping_cart.php?action=add_update_product&js-render-cart=true', form);
        })
        .on('keypress', '.js-cartQuantity', function (e) {
            const keypressed = (e.keyCode ? e.keyCode : e.which);
            if (13 === keypressed) {
                e.preventDefault();
            }
        })
        .on('keyup', '.js-cartQuantity', async e => {
            /** N�o necessita evento "added_to_cart" da Moengage, est� sendo tratado pelo focusout */
            const keypressed = (e.keyCode ? e.keyCode : e.which);
            const input = $(e.currentTarget);
            const form = input.closest('form');
            const newValue = parseFloat(input.val());
            const maxValue = parseFloat(input.data('max'));

            if (13 === keypressed) {
                e.preventDefault();

                // avoid setting amount under 1.
                if (newValue <= 0) {
                    input.val(1);
                    return;
                }

                // avoid setting amount above max unit
                if (newValue >= maxValue) {
                    input.val(maxValue)
                }

                await shoppingCartRender('/bebida/render_shopping_cart.php?action=add_update_product&js-render-cart=true', form.get(0));
            }
        })
        .on('focusout', '.js-cartQuantity', async e => {
            const input = $(e.currentTarget);
            const form = input.closest('form');
            const newValue = parseFloat(input.val());
            const maxValue = parseFloat(input.data('max'));
            const productId = parseInt(input.get(0).closest('.js-cartItem').querySelector('input[name="products_id[]"]').value, 10);
            const [factor, unit] = input.get(0).closest('.js-cartItem').querySelector(`input[name="units[${productId}]"]:checked`).value.split(',');
            const quantity = parseInt('UN' !== unit ? factor : 1, 10) * parseInt(input.val());

            e.preventDefault();

            // avoid setting amount under 1.
            if (newValue <= 0) {
                input.val(1);

                return;
            }

            // avoid setting amount above max unit
            if (newValue >= maxValue) {
                input.val(maxValue)
            }

            await shoppingCartRender('/bebida/render_shopping_cart.php?action=add_update_product&js-render-cart=true', form.get(0));

            let moengageEventData;
            try {
                moengageEventData = JSON.parse(document.querySelector(`input[name="moengage_event_data[${productId}]"]`).value);
                moengageEventData['product_quantity'] = parseInt(quantity, 10);
                sendMoengageEvent('added_to_cart', moengageEventData);
            } catch (error) {
            }
        })
        .on('change', '.js-productVariation', async e => {
            const variantion = $(e.currentTarget);
            const form = variantion.closest('form');
            const productId = parseInt(variantion.get(0).closest('.js-cartItem').querySelector('input[name="products_id[]"]').value, 10);
            const [factor, unit] = variantion.val().split(',');
            const quantity = parseInt('UN' !== unit ? factor : 1, 10) * parseInt(document.getElementById(`cart_quantity[${productId}]`).value, 10);

            await shoppingCartRender('/bebida/render_shopping_cart.php?action=add_update_product&js-render-cart=true', form.get(0));

            let moengageEventData;
            try {
                moengageEventData = JSON.parse(document.querySelector(`input[name="moengage_event_data[${productId}]"]`).value);
                moengageEventData['product_quantity'] = parseInt(quantity, 10);
                sendMoengageEvent('added_to_cart', moengageEventData);
            } catch (error) {
            }
        })
        .on('click', '.js-cartProductMinus', async e => {
            const button = $(e.currentTarget);
            const form = button.closest('form');
            const input = button.parent().find('input');
            const productId = parseInt(input.get(0).closest('.js-cartItem').querySelector('input[name="products_id[]"]').value, 10);
            const maxValue = parseInt(input.data('max'), 10);
            const oldValue = parseFloat(input.val());
            const newValue = parseFloat(oldValue) - 1;

            e.preventDefault();

            if (!button.hasClass('cartItem__quantity--disabled')) {
                if (1 !== maxValue) {
                    form.find('.js-cartProductPlus').removeClass('cartItem__quantity--disabled');
                    button.removeClass('cartItem__quantity--disabled');
                }

                if (newValue <= 1) {
                    input.val(1);
                    button.addClass('cartItem__quantity--disabled');
                }

                input.val(newValue);

                shoppingCartRender('/bebida/render_shopping_cart.php?action=add_update_product&js-render-cart=true', form.get(0));

                let moengageEventData;
                try {
                    moengageEventData = JSON.parse(document.querySelector(`input[name="moengage_event_data[${productId}]"]`).value);
                    moengageEventData['product_quantity'] = parseInt(input.val(), 10);
                    sendMoengageEvent('added_to_cart', moengageEventData);
                } catch (error) {
                }
            }
        })
        .on('click', '.js-cartProductPlus', async e => {
            const button = $(e.currentTarget);
            const form = button.closest('form');
            const input = button.parent().find("input");
            const productId = parseInt(input.get(0).closest('.js-cartItem').querySelector('input[name="products_id[]"]').value, 10);
            const oldValue = parseFloat(input.val());
            const maxValue = parseFloat(input[0].dataset.max);
            const newValue = parseFloat(oldValue) + 1;

            e.preventDefault();

            if (!button.hasClass('cartItem__quantity--disabled')) {
                if (1 !== maxValue) {
                    form.find('.js-cartProductMinus').removeClass('cartItem__quantity--disabled');
                    button.removeClass('cartItem__quantity--disabled');
                }
                if (newValue >= maxValue) {
                    button.addClass('cartItem__quantity--disabled');
                }
                // avoid setting amount under 1.
                if (oldValue <= 0) {
                    input.val(1);

                    return;
                }

                // avoid setting amount above max unit
                if (oldValue >= maxValue) {
                    input.val(maxValue);

                    return;
                }

                input.val(newValue);

                await shoppingCartRender('/bebida/render_shopping_cart.php?action=add_update_product&js-render-cart=true', form.get(0));

                let moengageEventData;
                try {
                    moengageEventData = JSON.parse(document.querySelector(`input[name="moengage_event_data[${productId}]"]`).value);
                    moengageEventData['product_quantity'] = parseInt(input.val(), 10);
                    sendMoengageEvent('added_to_cart', moengageEventData);
                } catch (error) {
                }
            }
        })
        .on('click', 'form[name="cart_quantity"] [type="submit"]', function (e) {
            const buttonClicked = $(this);
            const form = buttonClicked.closest('form');
            const allowIced = form.data('allowIced');
            const cartItemsQty = form.find('.js-cartItem').length;
            const allowedIcedItemsQty = form.find('[data-iced="1"]').length;
            const cep = cookie.get('cep');
            const firstPopupShow = false === cep && !cookie.get('totem');

            if ('checkout_x' === buttonClicked.prop('name')) {
                if (
                    firstPopupShow
                    || '00000000' === cep
                ) {
                    e.preventDefault();
                    showPostalcodePopup('/bebida/render_shopping_cart.php?action=add_update_product&js-render-cart=true', form);
                } else if (
                    allowIced
                    && allowedIcedItemsQty === cartItemsQty
                ) {
                    e.preventDefault();
                    showIcedPopup();
                }
            }
        })
        .on('change', '.js-toggleIced input', async e => {
            const icedToggle = e.currentTarget;
            const formData = new FormData();

            e.preventDefault();

            formData.append('iced', 0);
            if (icedToggle.checked) {
                formData.append('iced', 1);
            }
            [...icedToggle.closest('form').querySelectorAll('[type="submit"]')].forEach(e => e.disabled = true);

            await fetch('/bebida/iced.php', {
                method: 'POST',
                body: formData
            });
            await shoppingCartRender('/bebida/render_shopping_cart.php?js-render-cart=true');
        })
        .on('change', '.js-toggleRecurrency input', async e => {
            const recurrencyToggle = e.currentTarget;
            const formData = new FormData();

            e.preventDefault();

            formData.append('ever', 0);
            if (recurrencyToggle.checked) {
                formData.append('ever', 1);
            }
            [...recurrencyToggle.closest('form').querySelectorAll('[type="submit"]')].forEach(e => e.disabled = true);

            await fetch('/bebida/ever.php', {
                method: 'POST',
                body: formData
            });
            await shoppingCartRender('/bebida/render_shopping_cart.php?js-render-cart=true');
        })
        .on('click', '.js-popup', function (e) {
            const form = $(this).closest('form');

            $.fancybox.open(
                {
                    src: this.href + '&from-popup=1',
                    type: 'ajax'
                },
                {
                    parentEl: '.popup-login__wrapper',
                    ajax: {
                        settings: {
                            data: form.serializeArray(),
                            type: 'POST'
                        }
                    },
                    touch: false,
                    infobar: false,
                    toolbar: false,
                    closeClickOutside: false,
                }
            );
            e.preventDefault();
        })
        .on('click', '.js-cartCouponRemove', async e => {
            e.preventDefault();

            await shoppingCartRender('/bebida/render_shopping_cart.php?remove-cupom=1&js-render-cart=true');
        })
        .on('click', '.js-cartCouponOpen', function () {
            showCouponPopup();

            if ('function' === typeof ga) {
                ga('send', {
                    hitType: 'event',
                    eventCategory: 'Carrinho',
                    eventAction: 'Abertura cupom de desconto'
                });
            }
        })
        .on('click', '.js-giftWrap', function (e) {
            const notAllowedContainer = this.closest('.cartPage__giftWrap--notAllowed');
            const giftWrapWarningEl = notAllowedContainer?.parentElement.querySelector('.giftWrapWarning')
            const allowGitfWrap = null === notAllowedContainer;

            e.preventDefault();

            giftWrapWarningEl?.addEventListener('transitionend', e => {
                giftWrapWarningEl?.classList.add('giftWrapWarning--hidden');
            });

            if (allowGitfWrap) {
                $.fancybox.open({
                    src: document.querySelector('.giftWrapPopup'),
                    type: 'inline',
                    opts: {
                        touch: false,
                        infobar: false,
                        toolbar: false,
                        smallBtn: false,
                        beforeShow: (instance) => {
                            (async popup => {
                                const giftWrapResponse = await fetch('/bebida/gift_wrap.php');
                                const giftWrapHtml = await giftWrapResponse.text();

                                $(popup).html(giftWrapHtml);

                                if ('function' === typeof ga) {
                                    ga('send', {
                                        hitType: 'event',
                                        eventCategory: 'Carrinho',
                                        eventAction: 'Abertura popup embrulho'
                                    });
                                }
                            })(instance.current.src);
                        },
                    },
                });
            } else {
                giftWrapWarningEl?.classList.remove('giftWrapWarning--hidden');
            }
        })
        .on('click', '.js-scrollToNotification', function (e) {
            const firstNotification = document.querySelector('.cartItem__notification');
            if (firstNotification) {
                window.scrollTo({
                    top: firstNotification.closest('.cartItem').getBoundingClientRect().top
                        - document.body.getBoundingClientRect().top
                        - document.querySelector('.header').getBoundingClientRect().height
                        - 16
                });
            }
        })
        .on('change', '.js-select-ever', async function (e) {
            let formData = new FormData();//var
            formData.append('module', 'updateFrequencyCheckout');
            formData.append('frequency', $(this).val());

            const response = await fetch(
                'bebida/checkout_frequency.php',
                {
                    method: 'POST',
                    body: formData
                }
            )
            const data = await response.text();
        })
    ;

    delegate(document.querySelector('.shoppingCart-container'), '.js-cartCoupon', 'submit', async e => {
        const form = e.currentTarget;
        const promocodeEl = form.querySelector('input[name="promocode"]');
        const postData = new FormData();

        e.preventDefault();

        if (
            promocodeEl
            && '' !== promocodeEl.value
        ) {
            postData.append('promocode', promocodeEl.value);

            const response = await fetch(
                '/bebida/render_shopping_cart.php?action=apply_promocode&js-render-cart=true',
                {
                    method: 'POST',
                    body: postData,
                }
            );
            const isJson = response.headers.get('content-type')?.includes('application/json');
            if (isJson) {
                const data = await response.json();

                if (data.error) {
                    form.querySelector('.cartCoupon__error').innerHTML = data.error;
                }
            } else {
                const decoder = new TextDecoder('iso-8859-1');

                document.querySelector('.shoppingCart-container').innerHTML = decoder.decode(await response.arrayBuffer());
                document.querySelector('body').classList.remove('fancybox-active', 'compensate-for-scrollbar');
                handleSubtotalObserver();
            }
        }
    }, false);

    if (document.querySelector('[data-show-coupon-popup]')) {
        showCouponPopup();
    }
});
